import React from 'react';
import {
  Modal, Tabs,
} from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { articulosSeleccionadosSelector } from '../../../state/selectors/encargos.selectors';
import ArticulosDevolverList from './ArticulosDevolverList';
import DatosDevolucion from './DatosDevolucion';
import MotivosDevolucion from './MotivosDevolucion';
import FooterDevolver from './FooterDevolver';
import { devolverArticuloDeEncargo, } from '../../../state/actions/creators/encargos.actioncreator';

class DevolverModal extends React.PureComponent {

  constructor() {
    super();
    this.state = {
      devolverForm: {
        imprimirTicket: false,
        formaPago: null,
        motivoDevolucion: null,
        notaMotivoDevolucion: '',
        usuarioDevolucion: null,
        articulosSeleccionados: [],
        nombreClienteFinanciador: null,
        nifClienteFinanciador: null,
        mesesAFinanciar: null,
      },
    };
  }

  onChangeCheckImprimirTicket = (e) => {
    const { checked } = e.target;
    let { devolverForm } = this.state;
    devolverForm.imprimirTicket = checked;

    this.setState({
      devolverForm,
    });
  }

  onChangeFormaPago = (value) => {
    let mostrarDatosFinanciacion = false;
    const { core } = this.props;
    const { formasPago } = core || [];

    const formaPagoSeleccionada = formasPago.find(formaPago => formaPago.id === value);

    if ((formaPagoSeleccionada !== null) && formaPagoSeleccionada.es_financiacion) {
      mostrarDatosFinanciacion = true;
    }

    let { devolverForm } = this.state;
    devolverForm.formaPago = formaPagoSeleccionada.id;

    this.setState({
      mostrarDatosFinanciacion,
      devolverForm,
    });
  }

  onChangeMotivosDevolucion = (value) => {
    let { devolverForm } = this.state;
    devolverForm.motivoDevolucion = value;

    this.setState({
      devolverForm,
    });
  }

  onChangeNotaMotivoDevolucion = (e) => {
    const { value } = e.target;
    let { devolverForm } = this.state;
    devolverForm.notaMotivoDevolucion = value;

    this.setState({
      devolverForm,
    });
  }

  onChangeUsuarioDevolucion = (value) => {
    let { devolverForm } = this.state;
    devolverForm.usuarioDevolucion = value;

    this.setState({
      devolverForm,
    });
  }

  onChangeClienteFinanciador = (e) => {
    const { value } = e.target;
    let { devolverForm } = this.state;
    devolverForm.nombreClienteFinanciador = value;

    this.setState({
      devolverForm,
    });
  }

  onChangeNifClienteFinanciador = (e) => {
    const { value } = e.target;
    let { devolverForm } = this.state;
    devolverForm.nifClienteFinanciador = value;

    this.setState({
      devolverForm,
    });
  }

  onChangeMesesAFinanciar = (e) => {
    const { value } = e.target;
    let { devolverForm } = this.state;
    devolverForm.mesesAFinanciar = value;

    this.setState({
      devolverForm,
    });
  }

  onChangeUndsArticulo = (value, linea) => {
    let { devolverForm } = this.state;
    let { articulosSeleccionados } = devolverForm;
    for (let i = 0; i < articulosSeleccionados.length; i++) {
      if (articulosSeleccionados[i].lineaDetalle === linea){
        articulosSeleccionados[i].lineaUds = "" + value;
      }
    }

    this.state.devolverForm.articulosSeleccionados = articulosSeleccionados;

  }

  onDevolver = () => {
    const { devolverForm } = this.state;
    const { articulosSeleccionados, devolverArticuloDeEncargo,
      encargoId, tiendaId, onDevolver, } = this.props;
    devolverForm.encargoId = encargoId;
    devolverForm.tiendaId = tiendaId;
    devolverArticuloDeEncargo(devolverForm);
    onDevolver();
  }

  render() {
    const { visible, onClose, core, encargosWorkspace } = this.props;
    const { usuarios, formasPago, motivosDevolucion } = core || [];
    const { mostrarDatosFinanciacion } = this.state || false;
    const { promocion, tituloEspacioDeTrabajo, nombrePack } = encargosWorkspace || null;

    const { TabPane } = Tabs;
    const titulo = (promocion !== null) ? nombrePack : tituloEspacioDeTrabajo;

    function callback(key) {
      console.log(key);
    }

    return (
      <Modal
        className="devolucionModal"
        title=""
        visible={visible}
        closable={false}
        onCancel={() => onClose()}
        width="597px"
        style={{
          height: '612px',
        }}
        footer={[
          <FooterDevolver
            onDevolver={() => this.onDevolver()}
            onClose={onClose}
            onChangeCheckbox={value => this.onChangeCheckImprimirTicket(value)}
          />,
        ]}
      >
        <Tabs defaultActiveKey="1" onChange={callback}>

          <TabPane tab="Devolución" key="1">

            <ArticulosDevolverList
              articulosSeleccionados={[]}
              nombrePack={titulo}
              onChangeUndsArticulo={(value, linea) => this.onChangeUndsArticulo(value, linea)}
            />

            <DatosDevolucion
              onChangeUsuarioDevolucion={value => this.onChangeUsuarioDevolucion(value)}
              usuarios={usuarios}
              onChangeFormaPago={value => this.onChangeFormaPago(value)}
              mostrarDatosFinanciacion={mostrarDatosFinanciacion}
              formasPago={formasPago}
              onChangeClienteFinanciador={value => this.onChangeClienteFinanciador(value)}
              onChangeNifClienteFinanciador={value => this.onChangeNifClienteFinanciador(value)}
              onChangeMesesAFinanciar={value => this.onChangeMesesAFinanciar(value)}
            />

            <MotivosDevolucion
              onChangeNotaMotivoDevolucion={value => this.onChangeNotaMotivoDevolucion(value)}
              onChangeMotivosDevolucion={value => this.onChangeMotivosDevolucion(value)}
              motivosDevolucion={motivosDevolucion}
            />

          </TabPane>

          {/* <TabPane tab="Importes multiples" key="2">
            {JSON.stringify(articulosSeleccionados)}
          </TabPane> */}
        </Tabs>
      </Modal>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ devolverArticuloDeEncargo }, dispatch);
}

const mapStateToProps = state => ({
  core: state.core,
  encargosWorkspace: state.encargosWorkspace,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DevolverModal);
